import * as React from 'react';
import Card from '@mui/material/Card';
import PropTypes from 'prop-types';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

export default function Policy({ profile, name }) {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'grid',
      }}
    >
      <Card
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box
          alignItems="center"
          justifyContent="center"
          my="10%"
          mx="auto"
        >
          <Avatar
            src={profile}
            sx={{ width: 100, height: 100, margin: "auto"}}
            variant="square"
          />
          <CardContent>
            <div style={{ textAlign: "center" }}>
                <Typography gutterBottom variant="" component="div" sx={{ paddingTop:1, fontSize: 16, fontWeight: 'bold', display: 'inline-block', verticalAlign: 'middle' }}>
                    {name}
                </Typography>
            </div>
            <Typography gutterBottom variant="body2" color="text.secondary" component="div" sx={{ mx: "auto", textAlign: "center", fontSize: 10 }}>
              Policy
            </Typography>
          </CardContent>
        </Box>
      </Card>
    </Box>
  );
}

Policy.propTypes = {
  profile: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};